<template>
  <v-col cols="12" md="6">
    <v-list density="compact">
      <v-list-subheader>
        <span style="line-height: 36px">Телефоны:</span>
        <v-btn icon flat size="x-small" v-show="edit" @click="$emit('add')">
          <v-icon color="primary">add</v-icon>
        </v-btn>
      </v-list-subheader>
      <v-list-item
        v-for="(item, i) in phones"
        :key="i"
        active-color="primary"
      >
        <template v-slot:prepend>
          <v-icon color="primary">phone</v-icon>
        </template>
        <v-list-item-title class="text-wrap">{{ item.code }}{{ item.number }} ({{
            item.kind
          }})
        </v-list-item-title>
        <template v-slot:append>
          <v-btn icon flat size="x-small" v-show="edit" @click="$emit('edit', item)">
            <v-icon color="primary">edit</v-icon>
          </v-btn>
          <v-btn icon flat size="x-small" v-show="edit" @click="$emit('delete', item)">
            <v-icon color="primary">delete</v-icon>
          </v-btn>
        </template>
      </v-list-item>
      <v-list-item v-if="phones && phones.length === 0">
        <template v-slot:prepend>
          <v-icon color="primary">phone</v-icon>
        </template>
        <v-list-item-title>
          <span>не указан</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
export default {
  name: 'PhonesSection',
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    phones: {
      type: Array,
      default: () => []
    }
  },
  emits: ['add', 'edit', 'delete']
}
</script>
